import { CompanyListCertificationSortField, CompanyStatus } from "@/graphql/codegen/graphql"
import { CertificationStatus } from "@/screens/Companies/edit/components/certification/types"
import { createStatusMap } from "@/utils/statusMap"

export const companyStatusMap = createStatusMap<
  CompanyStatus,
  "primary" | "secondary" | "default" | "error" | "info" | "success" | "warning"
>([
  [CompanyStatus.Active, "success"],
  [CompanyStatus.Pending, "warning"],
  [CompanyStatus.Rejected, "error"],
  [CompanyStatus.Inactive, "secondary"],
])

export type SortableAccessorKey = "publicId" | "name"

export const accessorKeyToCompanyListCertificationSortField = new Map<
  SortableAccessorKey,
  CompanyListCertificationSortField
>([
  ["name", CompanyListCertificationSortField.Name],
  ["publicId", CompanyListCertificationSortField.PublicId],
])

export const companyListCertificationSortFieldToAccessoryKey = new Map<
  CompanyListCertificationSortField,
  SortableAccessorKey
>([
  [CompanyListCertificationSortField.Name, "name"],
  [CompanyListCertificationSortField.PublicId, "publicId"],
])

export const CertificationExpirationsStatusColorMap = new Map<CertificationStatus, string>([
  [CertificationStatus.EXPIRED, "text-red-500"],
  [CertificationStatus.LESS_THAN, "text-tertiary-yellow-500"],
  [CertificationStatus.MORE_THAN, "text-tertiary-green-500"],
  [CertificationStatus.NOT_FILED, "text-gray-500"],
])
